module.exports = __webpack_public_path__ + "img/combobox.e7557fe6.svg";